import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  untracked,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../../core/services/data/data.service';
import { EntityNavigatorComponent } from '../../entity-navigator/entity-navigator.component';
import { TranslatePipe } from '../../../pipes/translate/translate.pipe';

/**
 * BreadcrumbShipmentNavComponent component.
 * Provides UI presentation and event handling for breadcrumb shipment nav component.
 */
@Component({
  selector: 'app-breadcrumb-shipment-nav',
  standalone: true,
  imports: [CommonModule, FormsModule, EntityNavigatorComponent, TranslatePipe],
  templateUrl: './breadcrumb-shipment-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './breadcrumb-shipment-nav.component.scss',
})
export class BreadcrumbShipmentNavComponent {
  /** Injected service for data service. */
  private readonly dataService = inject(DataService);

  /** Property shipment input. */
  shipmentInput = '';

  /** Property current shipment. */
  private readonly currentShipment = this.dataService.currentShipment;
  /** Property shipment list navigation. */
  private readonly shipmentListNavigation =
    this.dataService.shipmentListNavigation;

  /** Property navigation state. */
  navigationState = computed(() => {
    this.shipmentListNavigation();
    const shipment = this.currentShipment();
    const route = this.dataService.getShipmentDetailsRoute();
    return this.dataService.getShipmentNavigationState(
      shipment?.id ?? route?.id
    );
  });

  constructor() {
    effect(() => {
      const shipment = this.currentShipment();
      const shipmentNo = shipment?.shipmentNo;
      if (shipmentNo == null || shipmentNo === '') return;

      untracked(() => {
        this.shipmentInput = String(shipmentNo);
      });
    });
  }

  /**
   * Handles on prev logic.
   */
  onPrev(): void {
    this.dataService.navigateAdjacentShipment(-1);
  }

  /**
   * Handles on next logic.
   */
  onNext(): void {
    this.dataService.navigateAdjacentShipment(1);
  }

  /**
   * Handles on input keydown logic.
   * @param event - The event
   */
  onInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onSubmit();
    }
  }

  /**
   * Handles on submit logic.
   */
  onSubmit(): void {
    this.dataService.navigateToShipmentReference(this.shipmentInput);
  }
}
